export default __webpack_public_path__ + "static/media/mais-infancia-home.ede4b532.png";